<template>
  <w-modal
    v-model="show"
    :submitButton="$t('buttons.save')"
    :title="$t(title)"
    :closeButton="$t('buttons.cancel')"
    :closeOnSubmit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="saveExam()"
    @close="close()"
  >
    <div class="row">
      <div class="form-group col-md-12">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div class="form-group col-md-6">
        <w-select :model="$schema.unit" :values="unitTypes" :title="$t($schema.unit.$schema.title)" />
      </div>

      <div class="form-group col-md-6" v-if="!isTeam">
        <w-select :model="$schema.sportId" :values="sports" :title="$t($schema.sportId.$schema.title)" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/exam.schema';
import { ExamUnitTypeTranslation, ExamUnitType } from '@/enums/examUnitType.enum';
import { tryParseInt } from '@/utils/number';

const emptyData = () => ({ name: '', unit: '', clubId: null, sportId: null, teamId: null });

// @vuese
// Modal egzaminu
// @group Components
export default {
  mixins: [manageMixin('exam', {}, emptyData)],
  props: {
    // Czy egzamin grupy treningowej
    isTeam: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  schema,
  computed: {
    title() {
      return this.id ? 'modals.exam-edit' : 'modals.exam-add';
    },
    unitTypes() {
      return Object.keys(ExamUnitType).map(unit => ({
        value: ExamUnitType[unit],
        text: this.$t(ExamUnitTypeTranslation[ExamUnitType[unit]])
      }));
    },
    sports() {
      return [{ value: null, text: this.$t('text.exam.sportGeneral') }, ...this.storeSports];
    },
    ...mapState({
      storeSports: state => state.sport.list.map(item => ({ value: item.id, text: item.name })),
      teamSportId: state => state.team.data.sport.id
    })
  },
  methods: {
    // @vuese
    // Zapisuje egzamin
    saveExam() {
      if (this.isTeam) {
        this.$schema.teamId.$model = tryParseInt(this.$route.params.teamId);
        this.$schema.sportId.$model = this.teamSportId;
      } else {
        this.$schema.clubId.$model = tryParseInt(this.$route.params.clubId);
      }
      this.save();
    }
  }
};
</script>
